import React, { Component } from "react";
import styled from "styled-components";
import { push } from "connected-react-router";
import { connect } from "react-redux";

import Slider from "../../components/Slider";
import CircleGraph from "../../components/graphs/CircleFillGraph";
import Graph from "../../components/graphs/ChannelEntityGraph";
import {
  Main,
  GraphDetailContainer,
  SliderContainer,
  MainArea,
  DetailArea,
  MainText,
  Title,
  Description,
  GraphDescription
} from "../../components/StyledComponents";
import appUrls from "../../config/appUrls";

const CircleGraphsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0px;
  width: 196px;
  float: right;
  @media (min-width: 1800px) {
    width: 287px;
    padding: 25px 0px;
  }
`;

const CircleGraphChild = styled.div`
  display: flex;
  flex: 1 1 50%;
  justify-content: flex-end;
`;

const CircleAndTextWrapper = styled.div`
  width: min-content;
  text-align: center;
  margin-bottom: 25%;
`;

const FilledGraphContainer = styled.div`
  height: 70px;
  width: 70px;

  @media (min-width: 1800px) {
    height: 115px;
    width: 115px;
  }
`;

const FilledGraphDetail = styled.div`
  font-size: 12px;
  line-height: 18px;
  margin-top: 10px;
  color: ${props => props.theme.text};
  @media (min-width: 1800px) {
    font-size: 18px;
    line-height: 30px;
    margin-top: 13px;
  }
`;

class Channel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailChosen: "ENTITY",
      data: [
        {
          id: 0,
          value: 25,
          name: "مركز تعهيد"
        },
        {
          id: 1,
          value: 78,
          name: "زمن الانتظار"
        },
        {
          id: 2,
          value: 84,
          name: "تكلفة الوحدة من الخدمة"
        },
        {
          id: 3,
          value: 24,
          name: "الانتاجية"
        }
      ]
    };
  }

  setChosenDetail = detailChosen => {
    this.setState({
      detailChosen
    });
  };

  showMoreAction = () => {
    if (this.state.detailChosen === "ENTITY") {
      this.props.push(appUrls.ENTITY_ZOOMED);
    } else {
      this.props.push(appUrls.CHANNEL_ZOOMED);
    }
  };

  render() {
    const { data } = this.state;
    const { theme } = this.props;
    return (
      <Main>
        <GraphDetailContainer>
          <MainArea>
            <GraphDescription>
              {window.innerWidth < 575
                ? "إختار أي قناة خدمة أو جهة حكومية لمعرفة المزيد"
                : "متوسط اداء الخدمات الحكومية لجميع الجهات الحكومية و علاقته بالقطاعات الاستراتيجية"}
            </GraphDescription>
            <Graph
              showMoreAction={this.showMoreAction}
              setChosenDetail={this.setChosenDetail}
            />
            <SliderContainer>
              <Slider theme={theme} />
            </SliderContainer>
          </MainArea>
          <DetailArea>
            <MainText> دليل مؤشر الخدمات الحكومية </MainText>
            <Title> قنوات تقديم الخدمة </Title>
            <Description>
              هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما
              سيلهي
            </Description>
            <CircleGraphsContainer>
              {data.map((item, i) => (
                <CircleGraphChild key={i}>
                  <CircleAndTextWrapper>
                    <FilledGraphContainer>
                      <CircleGraph
                        value={item.value}
                        title={item.name}
                        showValue={false}
                      />
                    </FilledGraphContainer>
                    <FilledGraphDetail>{item.name}</FilledGraphDetail>
                  </CircleAndTextWrapper>
                </CircleGraphChild>
              ))}
            </CircleGraphsContainer>
          </DetailArea>
        </GraphDetailContainer>
      </Main>
    );
  }
}

const mapStateToProps = state => ({
  theme: state.themes.theme
});

export default connect(
  mapStateToProps,
  {
    push
  }
)(Channel);
